import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EditChildForm } from "@/components/dashboard/EditChildForm";

interface EditProfileDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  childId: string;
  childData: {
    name: string;
    age: number;
    birthday?: string;
    profile_picture_url: string | null;
  };
}

export const EditProfileDialog = ({
  isOpen,
  onOpenChange,
  childId,
  childData,
}: EditProfileDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Profile</DialogTitle>
        </DialogHeader>
        <EditChildForm
          childId={childId}
          initialData={childData}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};